import { getThisWeekRange, getNextWeekRange, getLastSundayBeforeThisWeek } from '../../../../utils/weekRanges';

/** PO-line statuses that count as still open — mirrors the Open tab. */
export const OPEN_LINE_STATUSES = 'pending,partially_received';

/**
 * Query params for the "Due …" quick-filter tabs.
 *
 * Mirrors the Schedule Lines tabs of the same names so a planner sees the
 * same week cut on both surfaces — PO lines key off `delivery_date` where
 * schedules key off `schedule_date`. Closed and on-hold lines are excluded
 * from every window: a finished or paused line is not forward work and would
 * inflate the badge.
 *
 * Returns an empty object for any other tab, so callers can spread it safely.
 */
export function dueWindowParams(tab: string): Record<string, string | number | boolean> {
  if (tab === 'due_previous_weeks') {
    // Arrears: still open with a delivery date before this week's Monday.
    // Its own tab so Due This Week stays a clean planner view.
    return {
      delivery_date__lte: getLastSundayBeforeThisWeek(),
      status__in: OPEN_LINE_STATUSES,
      on_hold: false,
    };
  }
  if (tab === 'due_this_week') {
    const { from, to } = getThisWeekRange();
    return { delivery_date__gte: from, delivery_date__lte: to, status__in: OPEN_LINE_STATUSES, on_hold: false };
  }
  if (tab === 'due_next_week') {
    const { from, to } = getNextWeekRange();
    return { delivery_date__gte: from, delivery_date__lte: to, status__in: OPEN_LINE_STATUSES, on_hold: false };
  }
  return {};
}

